export default "__VITE_ASSET__DGFneDsh__"